module.exports = __webpack_public_path__ + "img/speed_white.e2a404f5.svg";